import React, { useEffect, useState } from 'react';
import 'assets/scss/home-banner.scss';
import imgBannerUser from 'assets/img/image_banner_user.png';
import { useBannerServices } from 'hooks/useBannerServices';
export const HomeBanner = () => {
	const [title, setTitle] = useState('');
	const [subtitle, setSubtitle] = useState('');
	const [content, setContent] = useState('');
	const { getBanner } = useBannerServices();

	useEffect(() => {
		getBanner()
			.then((res) => {
				setTitle(res.data.title);
				setSubtitle(res.data.subtitle);
				setContent(res.data.contents);
			})
			.catch((_) => {
				setTitle('CRÉDITO AUTOMOTRIZ');
				setSubtitle('¡Súbete a tu auto nuevo en cuotas bajas!');
				setContent('Financiamos todas las marcas');
			});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="banner-container">
			<div className="banner-content">
				<img src={imgBannerUser} alt="" />
				<div className="banner-text">
					<h1
						className="title-3"
						style={{
							marginBottom: 16,
						}}
					>
						{title}
					</h1>
					<p
						className="title-4"
						style={{
							marginBottom: 16,
						}}
					>
						{subtitle}
					</p>
					<p className="subtitle-1">{content}</p>
				</div>
			</div>
		</div>
	);
};
